import { render, staticRenderFns } from "./SituacaoRua.vue?vue&type=template&id=0aee1313"
import script from "./SituacaoRua.vue?vue&type=script&lang=js"
export * from "./SituacaoRua.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports